import { formatNip05 } from '../utils/profile.js'

// Renders a NIP-05 identifier as muted small text with a trailing
// glyph. The glyph carries a tooltip explaining what the user is
// looking at:
//   verified === 'verified'  → green ✓, "Nostr identity verified"
//   anything else            → ⓘ,       "Self-claimed; not verified"
// T16 shipped the verification backing; before that this component
// always rendered the ⓘ + self-claimed tooltip. Callers that don't
// run the useNip05Verification hook pass no prop and get the honest
// self-claimed default.
//
// Returns null when nip05 is missing or malformed; callers don't
// need to guard.
export function Nip05Display({ nip05, className = '', verified = 'unknown' }) {
  const formatted = formatNip05(nip05)
  if (!formatted) return null
  const isVerified = verified === 'verified'
  const tooltip = isVerified
    ? 'Nostr identity verified'
    : 'Self-claimed; not verified'
  return (
    <span className={`nip05-display ${className}`.trim()}>
      <span className="nip05-text">{formatted}</span>
      <span
        className={isVerified ? 'nip05-check' : 'nip05-info'}
        title={tooltip}
        aria-label={tooltip}
      >{isVerified ? '✓' : 'ⓘ'}</span>
    </span>
  )
}
